module.exports = "<nv-responsive-tabs tabs=\"vm.tabs\"></nv-responsive-tabs>";